import { Box, Text } from '@factorialco/deprecated-design-system'

import UserAvatar from 'modules/core/components/UserAvatar'
import { employeeUser } from 'modules/core/store/collections/users'

import type Employee from 'modules/employees/store/models/Employee'

interface Props {
  employee: Employee
}

const EmployeeCellContent = ({ employee }: Props) => {
  return (
    <>
      <Box flexDirection="row" alignItems="center" gap="s16">
        <UserAvatar size="s32" user={employeeUser(employee)} />
        <Text.Normal>{employeeUser(employee).fullName()}</Text.Normal>
      </Box>
    </>
  )
}

const EmployeeCell = ({ employee }: Props) => {
  return (
    <Box
      background="grey000White"
      flexDirection="row"
      justifyContent="spaceBetween"
      height="full"
      paddingX="s16"
      paddingY="s12"
      border={{
        all: {
          width: 's2',
          style: 'solid',
          color: 'grey000White',
        },
      }}
      gap="s16"
      style={{ width: '268px' }}
    >
      <EmployeeCellContent employee={employee} />
    </Box>
  )
}

export default EmployeeCell
